/* @jsx h */
import { defineComponent, h } from "vue";

export const AppSubpage = defineComponent({
  name: "AppSubpage",
  setup(_, { slots }) {
    return () => (
      <div class="flex flex-col overflow-hidden flex-1 h-full bg-base-300/30 lg:p-4">
        {slots.default && slots.default()}
      </div>
    );
  },
});

export const AppSubpageContent = defineComponent({
  name: "AppSubpageContent",
  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
    onScroll: {
      type: Function,
      default: undefined,
    },
  },
  setup(props, { slots }) {
    return () => (
      <div
        class={["flex-1 overflow-y-auto", props.noPadding ? "" : ""]}
        onScroll={props.onScroll as any}
      >
        {slots.default && slots.default()}
      </div>
    );
  },
});
